import { useCompany } from "../../components/CompanyProvider/CompanyProvider";
import { getAssignmentMode } from "./getAssignmentMode";
import { getPriceDisplay } from "./getPriceDisplay";
/**
 * usePriceFormat - Handles logic price display text and color
 * @returns Helper function to format price
 */
export const usePriceFormat = () => {
    const company = useCompany();
    const formatPrice = ({ displayPriceOverride, recipePrice, programMealPrice, assignmentQuantityForMeal, mealQuantity, myMealsConfig, recipeModuleConfig, shouldUseRecipePricing, }) => {
        const numberFormat = new Intl.NumberFormat(company.culture.cultureInfo, {
            style: "currency",
            currency: company.culture.currency,
        });
        // We use the presence of the config object to determine from where the format function is being called.
        const configObject = myMealsConfig || recipeModuleConfig;
        const assignmentMode = getAssignmentMode(configObject);
        const { ExtraRecipePriceColor, ExtraRecipePriceDisplay, ReducedRecipePriceColor, ReducedRecipePriceDisplay, AssignmentPriceText, } = configObject || {};
        const priceDisplay = getPriceDisplay({
            assignmentMode,
            AssignmentPriceText,
            displayPriceOverride,
            ExtraRecipePriceColor,
            ExtraRecipePriceDisplay,
            mealQuantity,
            numberFormat,
            programMealPrice,
            recipePrice,
            assignmentQuantityForMeal,
            ReducedRecipePriceColor,
            ReducedRecipePriceDisplay,
            shouldUseRecipePricing,
        });
        return Object.assign({}, priceDisplay);
    };
    return { formatPrice };
};
